
<form [formGroup]="form" class="is-fullwidth is-space-between is-flex">

  <div class="is-fullwidth">
    <div class="is-flex manual-setpoint is-fullwidth is-space-between">
      <div class="is-block">
        <app-text class="text-14 is-family-semiBold text-grey-90">{{ 'common-app.__DESIRED_TEMPERATURE' | AsyncLang | async }}</app-text>
        <ng-container *ngIf="isOff(); else consign">
          <app-text class="text-18 is-family-semiBold text-grey-70"> {{('common-settings.__OFF' | AsyncLang | async).toUpperCase() }}</app-text>
        </ng-container>
        <ng-template #consign>
          <div class="is-flex">
            <app-text class="text-18 is-family-medium text-grey-70 has-spacing-right-xxs"> {{ (setPoint((form.controls.setPoint.valueChanges | async)  | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE )) }}</app-text>
            <app-text class="text-18 is-family-semiBold text-grey-50" unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
          </div>
        </ng-template>
      </div>
      <div class="is-flex plus-minus">
        <app-minus
          longClick
          (mouseLongClick)="subtract()"
          (click)="subtract()"
          [colorClass]="colorClass('minus')"
          [ngClass]="{'disabled' : isButtonDisabled('minus')}"
          ga-event="ManualBoostLess"
        ></app-minus>
        <app-plus
          longClick
          (mouseLongClick)="add()"
          (click)="add()"
          [colorClass]="colorClass('plus')"
          [ngClass]="{'disabled' : isButtonDisabled('plus')}"
          ga-event="ManualBoostMore"
        ></app-plus>
      </div>
    </div>

    <app-end-time *ngIf="isSetPointOn()" [room]="room" [module]="module"></app-end-time>

  </div>
 

</form>
